import { KeywordEntity } from '@/services/types/store.type';

export const FILTER_KEYWORD_FOR_ALL: KeywordEntity = {
  value: 'all',
  label: '모두보기',
} as const;
